// services/reducaoIsp.js
import axiosInstance from './axiosInstance';

const REDUCAO_ISP_API_URL = '/reducao_isp';

const reducaoIspService = {
  async get(idempresa) {
    try {
      const response = await axiosInstance.get(`${REDUCAO_ISP_API_URL}/get.php?idempresa=${idempresa}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter redução ISP:', error);
      return [];
    }
  },

  async set(reducaoData) {
    try {
      const response = await axiosInstance.post(`${REDUCAO_ISP_API_URL}/set.php`, reducaoData);
      return response.data;
    } catch (error) {
      console.error('Erro ao guardar redução ISP:', error);
      throw error;
    }
  }
};

export default reducaoIspService;
